import React from 'react'
import { Transaction } from '@web/walter-lib/api'
import { AppSvg, icons } from '@web/walter-ui-kit'

interface Props {
    status: Transaction['status']
    subtype?: Transaction['subtype']
}

/**
 * Tx Notification Icon
 */
export function TxNotificationIcon({ status, subtype }: Props) {
    /**
     * Pending status
     */
    if (status === 'PENDING') {
        return <AppSvg svgName={icons.ic18RoundArrowClock} />
    }

    /**
     * Success status
     */
    if (status === 'SUCCESS') {
        if (subtype === 'STAKING') {
            return <AppSvg svgName={icons.ic18Percent} />
        }

        if (subtype === 'AFFILIATE') {
            return <AppSvg svgName={icons.ic18Gift} />
        }

        if (subtype === 'AIRDROP') {
            return <AppSvg svgName={icons.ic18CirclePlus} />
        }

        return <AppSvg svgName={icons.ic18Check} />
    }

    /**
     * Failed status
     */
    if (status === 'FAILED') {
        return <AppSvg svgName={icons.ic18CircleCross} />
    }

    return null
}

export default TxNotificationIcon
